var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.offer.type && _vm.offer.type.toLowerCase() !== 'other')?_c('v-chip',{attrs:{"color":"blue-grey lighten-5","x-small":"","label":""},domProps:{"textContent":_vm._s(_vm.offer.type)}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }